export default __webpack_public_path__ + "static/media/13-4129457.d5b1a209.png";